import React, { useEffect } from "react";
import { MDBCol, MDBContainer, MDBRow, MDBView } from "mdbreact";
import Sidebar from "../components/Sidebar";
import helpImage from "../../assets/help.png";
import {
  customerServiceText,
  emailText,
  helpPhoneText,
  insuranceBenefitAdministratorsText,
  needHelpTitleText,
} from "../../core/constants/strings";
import {
  helpEmailUrl,
  helpPhoneUrl,
  insuranceAdministratorsUrl,
  insuranceAdminsitratorsEmail,
} from "../../core/constants/endpoints";
import { useContactInformation } from "../../core/hooks/useContactInformation";
import executeWhenFinishToRender from "../../core/functions/executeWhenFinishToRender";
import HelpWidget from "presentation/components/HelpWidget";
import AttestationModal from "presentation/components/AttestationModal";

const HelpPage = () => {
  const contactInformation = useContactInformation();

  useEffect(() => {
    if (!contactInformation.gettingContactInformation) {
      executeWhenFinishToRender();
    }
  }, [contactInformation.gettingContactInformation]);

  return (
    <MDBView className="full">
      <MDBContainer fluid className="h-100">
        <MDBRow className="h-100 align-content-start bg-alabaster">
          <Sidebar className="d-none d-md-flex" />
          <MDBCol className="py-3">
            <h1 className="h2-responsive font-weight-semi-bold text-center mb-3 tk-bree-serif">
              {needHelpTitleText}
            </h1>
            <HelpWidget
              title={insuranceBenefitAdministratorsText}
              description={customerServiceText}
              image={helpImage}
              leftButtonTitle={emailText}
              rightButtonTitle={
                contactInformation.contactInformation?.phone || helpPhoneText
              }
              leftHref={
                !contactInformation.gettingContactInformation &&
                contactInformation.contactInformation?.email
                  ? helpEmailUrl.replace(
                      "{email}",
                      contactInformation.contactInformation.email.toLowerCase()
                    )
                  : insuranceAdminsitratorsEmail
              }
              rightHref={
                !contactInformation.gettingContactInformation &&
                contactInformation.contactInformation?.phone
                  ? helpPhoneUrl.replace(
                      "{phone}",
                      contactInformation.contactInformation.phone.replace(
                        /[^\w\s]/gi,
                        ""
                      )
                    )
                  : insuranceAdministratorsUrl
              }
            />
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <AttestationModal />
    </MDBView>
  );
};

export default HelpPage;
